import {useCallback} from 'react'

import {htmlStringToReactElement} from '@s-ui/js/lib/react'

import {DEFAULT_PRICE_INDICATOR_CONFIG, PRICE_INDICATOR_CONFIG_BY_OFFER_TYPE} from '../config.js'

const usePriceIndicator = ({rank, offerTypeId}) => {
  const getDescription = useCallback(offerTypeId => {
    const priceIndicatorConfig = PRICE_INDICATOR_CONFIG_BY_OFFER_TYPE[offerTypeId] || DEFAULT_PRICE_INDICATOR_CONFIG
    const {DESCRIPTION} = priceIndicatorConfig.RANKS[rank]
    return htmlStringToReactElement(priceIndicatorConfig.DESCRIPTION.replace('%{desciption}', DESCRIPTION))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getFaqs = useCallback(offerTypeId => {
    const priceIndicatorConfig = PRICE_INDICATOR_CONFIG_BY_OFFER_TYPE[offerTypeId] || DEFAULT_PRICE_INDICATOR_CONFIG
    return priceIndicatorConfig.FAQS
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getRanksByOrder = useCallback(
    offerTypeId => {
      const priceIndicatorConfig = PRICE_INDICATOR_CONFIG_BY_OFFER_TYPE[offerTypeId] || DEFAULT_PRICE_INDICATOR_CONFIG
      return Object.entries(priceIndicatorConfig.RANKS)
        .reverse()
        .map(([id, {COLOR, LABEL}]) => {
          const isHighlighted = Number(id) === rank
          return {color: COLOR, isHighlighted, label: LABEL}
        })
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )

  return {faqs: getFaqs(offerTypeId), description: getDescription(offerTypeId), ranks: getRanksByOrder(offerTypeId)}
}

export {usePriceIndicator}
